import { useState } from "react";
import {
  RiCloseLine,
  RiCodeLine,
  RiFileCopyLine,
  RiCheckLine,
  RiMailLine,
} from "react-icons/ri";

const TemplatePreview = ({ template, onClose }) => {
  const [viewMode, setViewMode] = useState("preview"); // 'preview' or 'code'
  const [copied, setCopied] = useState(false);

  const htmlCode = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${template.subject}</title>
  <style>
    body { font-family: Arial, sans-serif; line-height: 1.6; }
    .container { max-width: 600px; margin: 0 auto; padding: 20px; }
    .header { text-align: center; padding: 20px 0; }
    .content { padding: 20px 0; }
    .footer { text-align: center; padding: 20px 0; color: #666; }
  </style>
</head>
<body>
  <div class="container">
    <div class="content">
      ${template.content.replace(/\n/g, "<br>")}
    </div>
  </div>
</body>
</html>`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(htmlCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-secondary-200">
          <div className="flex items-center space-x-3">
            <RiMailLine className="w-6 h-6 text-primary-500" />
            <h2 className="text-xl font-semibold text-secondary-900">
              Template Preview
            </h2>
          </div>
          <div className="flex items-center space-x-2">
            <div className="flex rounded-lg border border-secondary-200 p-1">
              <button
                onClick={() => setViewMode("preview")}
                className={`px-3 py-1.5 rounded ${
                  viewMode === "preview"
                    ? "bg-secondary-100 text-secondary-900"
                    : "text-secondary-600 hover:bg-secondary-50"
                }`}
              >
                Preview
              </button>
              <button
                onClick={() => setViewMode("code")}
                className={`px-3 py-1.5 rounded flex items-center ${
                  viewMode === "code"
                    ? "bg-secondary-100 text-secondary-900"
                    : "text-secondary-600 hover:bg-secondary-50"
                }`}
              >
                <RiCodeLine className="w-4 h-4 mr-1" />
                HTML
              </button>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-secondary-50 rounded-lg"
            >
              <RiCloseLine className="w-6 h-6 text-secondary-500" />
            </button>
          </div>
        </div>

        <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)]">
          {viewMode === "preview" ? (
            <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-sm border border-secondary-200">
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-4">
                  {template.subject}
                </h3>
                <div className="prose prose-sm">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: template.content.replace(/\n/g, "<br>"),
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="relative">
              <pre className="bg-secondary-900 text-secondary-100 p-4 rounded-lg overflow-x-auto">
                <code className="text-sm">{htmlCode}</code>
              </pre>
              <button
                onClick={copyToClipboard}
                className="absolute top-4 right-4 p-2 bg-secondary-800 text-secondary-100 rounded-lg hover:bg-secondary-700 transition-colors"
              >
                {copied ? (
                  <RiCheckLine className="w-5 h-5 text-green-500" />
                ) : (
                  <RiFileCopyLine className="w-5 h-5" />
                )}
              </button>
            </div>
          )}

          <div className="mt-6">
            <h4 className="font-medium text-secondary-900 mb-2">
              Variables Used
            </h4>
            <div className="flex flex-wrap gap-2">
              {template.variables.map((variable) => (
                <span
                  key={variable}
                  className="px-2 py-1 bg-primary-50 text-primary-700 rounded text-sm"
                >
                  {`{${variable}}`}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatePreview;
